import './legacy_jquery'

// LEGACY JS for Cart

function cart_ready() {
  $('.email_order_order_items_attributes_period').change(function () {
    $.post("/cart/update-term", {
      order_item_id: $(this).data("order-item-id"),
      period: $(this).val()
    });
  });

  $('.domain-term-select').change(function () {
    $.post("/cart/update-term", {
      order_item_id: $(this).data("order-item-id"),
      period: $(this).val()
    });
  });

  $("select.domain-registrant").change(function () {
    $.post("/cart/update-registrant", {
      order_item_id: $(this).data("order-item-id"),
      domain_contact_id: $(this).val()
    }, function (res) {
      $('#' + res.element_id).html(res.domain_contact);
    });
  });

  $("select.domain-admin").change(function () {
    $.post("/cart/update-admin", {
      order_item_id: $(this).data("order-item-id"),
      domain_contact_id: $(this).val()
    }, function (res) {
      $('#' + res.element_id).html(res.domain_contact);
    });
  });
}

$(document).ready(cart_ready);
$(document).on('turbo:load', cart_ready);

